/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Hidden_Until_RoundInputs */



/**
* | output |
* | --- |
* | "Deck submitted — hidden until round starts" |
*
* @param {Decks_Hidden_Until_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_hidden_until_round = /** @type {((inputs?: Decks_Hidden_Until_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Hidden_Until_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deck soumis — masqué jusqu'au début de la manche")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mazo enviado — oculto hasta que empiece la ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Deck enviado — oculto até o início da rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mazzo inviato — nascosto fino all'inizio del round")
	return /** @type {LocalizedString} */ ("Deck submitted — hidden until round starts")
});